export function getR6ConnectionErrorMessage(error, translate) {
  const message = error?.message || String(error || "");
  if (/设备型号不匹配|未知设备/.test(message)) {
    return translate("cyberboardR6.unsupportedDevice");
  }
  if (
    /无法打开.*串口|Failed to (?:execute 'open' on 'SerialPort'|open serial port)|port.*busy/i.test(
      message
    )
  ) {
    return translate("cyberboardR6.portUnavailable");
  }
  if (/不支持 Web Serial CDC/.test(message)) {
    return translate("cyberboardR6.serialUnsupported");
  }
  return "";
}
